import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "app-confirm-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrl: "./confirm-dialog.component.scss",
	standalone: false
})
export class ConfirmDialogComponent {
	constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) { }

	close() {
		this.dialogRef.close();
	}

	ok() {
		this.dialogRef.close("ok");
	}
}